import Vue from 'vue';
import GuessBoardGame from './components/GuessBoardGame.vue';

new Vue({
  el: '#app',
  render(h) {
    return h(GuessBoardGame, {
      props: { details: JSON.parse(decodeURIComponent(atob(gameDetails))) },
    });
  },
});
